let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i5NTp")).then(() => parcelRequire('9Gfmu'));